( function ( _s ) {
	_s.fn.dropdown = function () {
		return this.el.forEach( el => {
			if ( window.SlimSelect ) {
				const _dropdown = _s( el );
				const isMultiple = el.hasAttribute( 'multiple' ) ? true : false;
				const config = JSON.parse( _dropdown.attr( 'slim-config' ) || '{}' );
				let _slimDropdownMain = false;
				let _slimDropdownContent = false;
				const hasCAS = _dropdown.find( '[data-cas-number]' ).length;
				const hasNAICS = _dropdown.find( '[data-naics]' ).length;
				const hasOptGroups = _dropdown.find( 'optgroup' ).length;

				_dropdown.addClass( isMultiple ? 'dropdown-multiple' : 'dropdown-single' );

				const checkOverflow = () => {
					if ( ! _slimDropdownMain.length ) return;

					const _selectedValuesContainer = _slimDropdownMain.find( '.ss-values' );

					if ( _selectedValuesContainer.length ) {
						const selectedValuesContainerElement =
							_selectedValuesContainer.firstElement();

						/** If values container has a placeholder it means there are no selected values, therefore, there's no overflow */
						if ( _selectedValuesContainer.find( '.ss-placeholder' ).length ) {
							_selectedValuesContainer.removeClass( 'overflown' );
							return;
						}

						_selectedValuesContainer.toggleClass(
							'overflown',
							selectedValuesContainerElement.scrollWidth >
								selectedValuesContainerElement.clientWidth
						);
					}
				};

				const closeDropdown = () => {
					if ( el.slim && el.slim.settings.isOpen ) {
						el.slim.close();
					}
				};

				_dropdown.find( '[data-cas-number], [data-naics]' ).each( option => {
					// prettier-ignore
					const attribute = hasCAS && 'data-cas-number' || hasNAICS && 'data-naics' || false;

					if ( attribute ) {
						const optionHTMLValue = `
                        <div class="option-label ${ attribute }">${ _s( option ).text() }</div>
                        <div class="option-code">${ _s( option ).attr( attribute ) }</div>
                        `;
						_s( option )
							.addClass( attribute )
							.attr( 'data-text', _s( option ).text() )
							.attr( 'data-html', optionHTMLValue );
					}
				} );

				_dropdown.find( 'optgroup' ).each( optionGroup => {
					const _optGroupOptions = _s( optionGroup ).find( 'option' );
					let searchText = ' ';

					_optGroupOptions.each( option => {
						const _option = _s( option );
						const searchTags = JSON.parse( _option.attr( 'search-tags' ) || '{}' );

						let optionSearchText = option.hasAttribute( 'data-html' )
							? _option.attr( 'data-html' )
							: _option.text();

						if ( searchTags.length ) {
							optionSearchText += ' ' + searchTags.join( ' ' );
						}

						searchText += ' ' + optionSearchText;
					} );

					/** Remove HTML tags */
					searchText = searchText.replace( /(<([^>]+)>)/gi, '' );

					_optGroupOptions.each( option => {
						const _option = _s( option );
						const optionText = option.hasAttribute( 'data-html' )
							? _option.attr( 'data-html' )
							: _option.text();

						_option.attr(
							'data-html',
							`${ optionText } <div class="d-none">${ searchText }</div>`
						);
					} );
				} );

				new window.SlimSelect( {
					select: el,
					settings: {
						...{
							closeOnSelect: ! isMultiple,
							allowDeselect: isMultiple,
							searchHighlight: true,
						},
						...config,
					},
					events: {
						afterChange: () => {
							if ( _slimDropdownMain.length ) {
								checkOverflow();
							}
						},
						searchFilter: ( option, search ) => {
							/**
							 * For some dropdowns we need to search the HTML against the search value,
							 * since options can have HTML code for the CAS number or NAICS
							 */

							return (
								( ( hasOptGroups ||
									( hasCAS && option.data.casNumber ) ||
									( hasNAICS && option.data.naics ) ) &&
									option.html
										.replace( /(<([^>]+)>)/gi, '' )
										.toLowerCase()
										.includes( search.toLowerCase() ) ) ||
								option.text.toLowerCase().includes( search.toLowerCase() )
							);
						},
						afterOpen: () => {
							if ( _slimDropdownContent.length ) {
								const appHeight = parseInt(
									window.getRootProperty( '--app-height' )
								);
								const dropdownContentHeight =
									_slimDropdownContent.firstElement().clientHeight;
								const dropdownContentTopOffset = parseInt(
									_slimDropdownContent.offset().top
								);

								if (
									dropdownContentTopOffset -
										window.scrollY +
										dropdownContentHeight >
									appHeight
								) {
									const bottomSpace =
										appHeight -
										( dropdownContentTopOffset - window.scrollY ) -
										5;

									window.setRootProperty(
										'--dropdown-content-max-height',
										bottomSpace + 'px'
									);

									_slimDropdownContent.addClass( 'max-height' );

									setTimeout( () => {
										const topSpace =
											parseInt( _slimDropdownMain.offset().top ) -
											window.scrollY -
											5;

										if ( topSpace > bottomSpace ) {
											window.setRootProperty(
												'--dropdown-content-max-height',
												topSpace + 'px'
											);
										}
									}, 500 );
								} else {
									_slimDropdownContent.removeClass( 'max-height' );
								}
							}
						},
						afterClose: () => {
							_slimDropdownContent.removeClass( 'max-height' );
						},
					},
				} );

				if ( el.slim ) {
					_slimDropdownMain = _dropdown
						.parent()
						.find( `.ss-main[data-id=${ el.slim.settings.id }]` );

					_slimDropdownContent = _s( `.ss-content[data-id=${ el.slim.settings.id }]` );

					/** Add ellipsis if dropdown is initialized with selected values and available space is overflown */
					checkOverflow();
				}

				_s( window ).on( 'scroll', () => {
					closeDropdown();
				} );

				_dropdown.on( 'fr:close-dropdown', () => {
					closeDropdown();
				} );

				_dropdown.on( 'fr:dropdown-selection-cleared', () => {
					checkOverflow();
				} );
			}
		} );
	};

	_s( document ).ready( () => {
		const _elements = _s( 'select' );

		if ( _elements.length ) {
			window
				.fetchInject( [
					'https://cdnjs.cloudflare.com/ajax/libs/slim-select/2.8.1/slimselect.min.js',
					'https://cdnjs.cloudflare.com/ajax/libs/slim-select/2.8.1/slimselect.css',
				] )
				.then( () => {
					_elements.dropdown();
				} );
		}
	} );
} )( window._s );
